/* Olfé "30 jaar, 30%" — campagnepagina /pages/30-jaar (sectie olfe-30jaar).
   ALLE TEKSTEN STAAN IN CONFIG HIERONDER. Tijden zijn Nederlandse tijd (Europe/Amsterdam).
   Verlengen: zet een nieuwe fase vóór 'na' (met eigen 'tot') of pas de teksten van 'na' aan.
   Testen (alleen in een preview, niet op het live thema): ?test-tijd=2026-10-24T12:00 */
(function () {
  var CONFIG = {
    tijdzone: 'Europe/Amsterdam',
    code: 'JARIG',   // staat deze code in het winkelmandje, dan toont de banner 'smallMetCode'
    fases: [
      {
        id: 'voor',
        tot: '2026-10-24T00:00',
        nl: {
          label: 'Zaterdag 24 oktober',
          heading: 'Morgen word ik <em>30</em>',
          sub: 'Daarom krijg je alleen morgen 30% op alles',
          line: 'Zet makkelijk je favorieten klaar voor morgen.',
          small: 'Morgen krijg je je verjaardagscode in je mail.'
        },
        en: {
          label: 'Saturday 24 October',
          heading: 'Tomorrow I turn <em>30</em>',
          sub: 'So tomorrow only, you get 30% off everything',
          line: 'Get your favourites ready for tomorrow.',
          small: 'Tomorrow you\u2019ll get your birthday code by email.'
        }
      },
      {
        id: 'vandaag',
        tot: '2026-10-26T10:00',   // verlengd tot ma 26-10 10:00 (Dani 24-10)
        nl: {
          label: 'Alleen vandaag',
          heading: 'Vandaag word ik <em>30</em>',
          sub: 'Daarom krijg je vandaag 30% op alles',
          line: 'Kies je favorieten, de 30% gaat van je totaal af.',
          // Code al in het winkelmandje (via de maillink) -> smallMetCode, anders small.
          smallMetCode: 'Je verjaardagscode JARIG is al toegepast in je winkelmandje.',
          small: 'Gebruik code JARIG bij het afrekenen.'
        },
        en: {
          label: 'Today only',
          heading: 'Today I turn <em>30</em>',
          sub: 'So today you get 30% off everything',
          line: 'Pick your favourites, the 30% comes off your total.',
          smallMetCode: 'Your birthday code JARIG is already applied to your bag.',
          small: 'Use code JARIG at checkout.'
        }
      },
      {
        id: 'na',
        tot: null,
        nl: {
          label: '',
          heading: 'Bedankt voor het meevieren',
          sub: 'De actie is voorbij.',
          line: '',
          small: ''
        },
        en: {
          label: '',
          heading: 'Thank you for celebrating with me',
          sub: 'The offer has ended.',
          line: '',
          small: ''
        }
      }
    ],
    categorieen: {
      nl: { all: 'Alles', set: 'Midnight-sets', legging: 'Leggings', beha: 'Sportbeha’s', top: 'Shirts en tanktops', trui: 'Truien', outlet: 'Outlet' },
      en: { all: 'All', set: 'Midnight sets', legging: 'Leggings', beha: 'Sports bras', top: 'Tees and tanks', trui: 'Sweaters', outlet: 'Outlet' }
    }
  };

  var root = document.querySelector('[data-o30]');
  if (!root) return;

  var path = location.pathname;
  var lang = /^\/en(\/|$)/.test(path) ? 'en' : 'nl';

  // Huidige tijd in Amsterdam als "YYYY-MM-DDTHH:MM" (zelfde vorm als 'tot').
  function amsterdamNow() {
    var test = new URLSearchParams(location.search).get('test-tijd');
    var preview = window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main';
    if (test && (preview || (window.Shopify && Shopify.designMode))) return test.slice(0, 16);
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: CONFIG.tijdzone, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return o.year + '-' + o.month + '-' + o.day + 'T' + o.hour + ':' + o.minute;
    } catch (e) {
      return new Date().toISOString().slice(0, 16);
    }
  }

  function currentPhase() {
    var now = amsterdamNow();
    for (var i = 0; i < CONFIG.fases.length; i++) {
      var f = CONFIG.fases[i];
      if (!f.tot || now < f.tot) return f;
    }
    return CONFIG.fases[CONFIG.fases.length - 1];
  }

  var codeInCart = false;
  function renderText() {
    var f = currentPhase();
    var t = Object.assign({}, f[lang] || f.nl);
    if (codeInCart && t.smallMetCode) t.small = t.smallMetCode;
    root.setAttribute('data-o30-phase', f.id);
    Array.prototype.forEach.call(root.querySelectorAll('[data-o30-k]'), function (el) {
      var k = el.getAttribute('data-o30-k');
      var v = t[k] || '';
      if (k === 'heading') el.innerHTML = v; else el.textContent = v;
      el.hidden = !v;
    });
    var names = CONFIG.categorieen[lang] || CONFIG.categorieen.nl;
    Array.prototype.forEach.call(root.querySelectorAll('[data-o30-catname]'), function (el) {
      el.textContent = names[el.getAttribute('data-o30-catname')] || '';
    });
    return f;
  }
  var phase = renderText();
  // Kijk of de code (via de maillink /discount/JARIG) al in het winkelmandje zit.
  fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var c = String(CONFIG.code || '').toLowerCase();
      codeInCart = (cart.discount_codes || []).some(function (d) { return d && String(d.code).toLowerCase() === c; });
      if (codeInCart) phase = renderText();
    })
    .catch(function () {});
  // Fase wisselt om middernacht ook zonder herladen.
  setInterval(function () { if (currentPhase().id !== phase.id) phase = renderText(); }, 60000);

  // ---------- producten (gewone themakaarten uit de collectiepagina) ----------
  var types = {};
  try { types = JSON.parse(root.querySelector('[data-o30-types]').textContent); } catch (e) {}
  var grid = root.querySelector('[data-o30-grid]');
  var activeCat = 'all';

  function cardCells() {
    return Array.prototype.map.call(grid.querySelectorAll('.product-card'), function (card) {
      var li = card.closest('li'); var cell = li && grid.contains(li) ? li : card;
      var a = card.querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return { cell: cell, cat: m ? (types[decodeURIComponent(m[1])] || 'overig') : 'overig' };
    });
  }

  function applyFilter() {
    cardCells().forEach(function (c) {
      c.cell.hidden = !(activeCat === 'all' || c.cat === activeCat);
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-o30-cat]'), function (b) {
    b.addEventListener('click', function () {
      activeCat = b.getAttribute('data-o30-cat');
      Array.prototype.forEach.call(root.querySelectorAll('[data-o30-cat]'), function (x) {
        var on = x === b;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyFilter();
      b.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      var top = grid.getBoundingClientRect().top;
      var cats = root.querySelector('[data-o30-cats]');
      var offset = (cats ? cats.offsetHeight : 0) + (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')) || 0);
      if (top < offset) window.scrollBy({ top: top - offset - 8, behavior: 'smooth' });
    });
  });

  // Sticky categoriebalk (mobiel) direct onder wat bovenaan blijft staan (aankondiging + header,
  // die bij scrollen kan wegschuiven). Het thema zet --sticky-header-height niet altijd.
  var catsBar = root.querySelector('[data-o30-cats]');
  if (catsBar) {
    var lastTop = -1;
    var placeCats = function () {
      var b = 0;
      Array.prototype.slice.call(document.querySelectorAll('.shopify-section-group-header-group'))
        .map(function (el) {
          // De header schuift zelf weg (transform) terwijl zijn sectie blijft staan: meet de header.
          var inner = el.querySelector('header[is=sticky-header]');
          return { el: el, r: (inner || el).getBoundingClientRect() };
        })
        .filter(function (x) { var p = getComputedStyle(x.el).position; return (p === 'sticky' || p === 'fixed') && x.r.height > 0; })
        .sort(function (a, c) { return a.r.top - c.r.top; })
        .forEach(function (x) { if (x.r.top <= b + 2 && x.r.bottom > b) b = x.r.bottom; });
      b = Math.max(0, Math.round(b));
      if (b !== lastTop) { lastTop = b; catsBar.style.setProperty('--o30-top', b + 'px'); }
    };
    var queued = false;
    var onScroll = function () { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; placeCats(); }); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    // Header schuift met een animatie weg/terug: even blijven meten na het scrollen.
    document.addEventListener('transitionend', onScroll, true);
    placeCats();
  }

  if (grid) {
    var rte = grid.closest('.rte');
    if (rte) rte.classList.remove('rte');
    var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var handle = grid.getAttribute('data-collection') || '30-jaar';
    var view = grid.getAttribute('data-view') || '30-jaar';
    fetch(shopRoot + 'collections/' + handle + '?view=' + encodeURIComponent(view), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sec = doc.querySelector('[id$="__main-collection"]');
        if (!sec || !sec.querySelector('.product-card')) throw new Error('geen kaarten');
        grid.innerHTML = sec.outerHTML;
        Array.prototype.forEach.call(grid.querySelectorAll('script'), function (old) {
          if (old.type === 'application/ld+json') { old.remove(); return; }
          var s = document.createElement('script');
          if (old.src) { s.src = old.src; s.async = false; } else { s.textContent = old.textContent; }
          old.replaceWith(s);
        });
        grid.classList.add('is-loaded');
        applyFilter();
      })
      .catch(function () { grid.classList.add('is-loaded'); });
  }
})();
